import type { ExpressionPaneProps } from "./components/ExpressionPane";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyImport, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "ExpressionPane" */ "./lazyIndex"), { name: "ExpressionPane" });

export const ExpressionPane: LazyComponent<ExpressionPaneProps, unknown, void> = createLazyComponent(lazyModule, m => m.ExpressionPane);
export const lazyToggleExpressionPane: LazyImport<typeof lazyIndex.toggleExpressionPane, typeof lazyModule> = new LazyImport(lazyModule, m => m.toggleExpressionPane);
